import { render, staticRenderFns } from "./CompanyInput.vue?vue&type=template&id=4484586c&scoped=true"
import script from "./CompanyInput.vue?vue&type=script&lang=js"
export * from "./CompanyInput.vue?vue&type=script&lang=js"
import style0 from "./CompanyInput.vue?vue&type=style&index=0&id=4484586c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484586c",
  null
  
)

export default component.exports